import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\Reveal.tsx");
